import renameKeyOfObjectOrSetValue from "../renameKeyOfObjectOrSetValue";
import deleteKeyOfObject from "../deleteKeyOfObject";
// Transform block tree state statement to block server api
const BlockStatementTransformer = (origin) => {

    const data = { ...origin };
    data.variable_redirect == null ? deleteKeyOfObject(data, 'variable_redirect') : renameKeyOfObjectOrSetValue(data, { new_key : 'statement_redirect_var', old_key : 'variable_redirect' }, data.variable_redirect.name)
    
    return data
}

export default BlockStatementTransformer;